import React from 'react';
import PropTypes from 'prop-types';
import { ResponsiveContainer, XAxis, YAxis, Legend, Tooltip, LineChart, Line } from 'recharts';
import { round10, numberShortener, formatPercentageValue } from '../../config/utils';
import './ChartWrapper.css';

export function ChartWrapper (props) {
  return props.chart.length === 0 
    ? (<div id="chart-wrapper"></div>) 
    : (
      <div id="chart-wrapper">
        <ResponsiveContainer width="100%">
          <LineChart data={props.chart}>
            <XAxis 
              dataKey="name"
              minTickGap={10}
            />
            <YAxis 
              tickFormatter={(val) => round10(val, 0)}
              type="number"
              label={{ value: "ROI (%)", angle: -90, position: 'insideLeft' }}
              domain={['dataMin', 'dataMax']}
              // domain={[
              //   dataMin => round10(Math.max(dataMin - 1000, 0), 3), 
              //   dataMax => round10(dataMax + 1000, 3)
              // ]} 
            />
            <Legend />
            <Tooltip 
              formatter={(val) => round10(val, -2) + '%'}
            />
            <Line type="monotone" dataKey="enhanced" name="Bitcoin enhanced portfolio" stroke="#ff6161" dot={false} />
            <Line type="monotone" dataKey="traditional" name="Traditional portfolio" stroke="#135373" dot={false} />
          </LineChart>
        </ResponsiveContainer>
      </div>
    );
}


// WEBPACK FOOTER //
// ./src/components/ChartWrapper/ChartWrapper.js